import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { PropertyListService } from './property-list.service';
import { filtersActions, propertyListActions } from './property-list.actions';
import { EMPTY, map, switchMap, withLatestFrom } from 'rxjs';
import { selectFilters } from './property-list.selectors';
import { MessageService } from '@letly/ui-common';
import { ToastSeverity } from '@letly/models';
import { HelpersService } from '@letly/services';

@Injectable()
export class PropertyListEffect {

  private actions$ = inject(Actions);
  private store = inject(Store);
  private propertyListService = inject(PropertyListService);
  private helperService = inject(HelpersService);
  private messageService = inject(MessageService);


  private loadProperties$ = createEffect(() =>
    this.actions$.pipe(
      ofType(propertyListActions.load, filtersActions.updateActiveFilters),
      withLatestFrom(this.store.select(selectFilters)),
      switchMap(([action, filters]) => {
          if (action.type === filtersActions.updateActiveFilters.type) {
            const updatedKeys = Object.keys(action).filter(k => k !== 'type');
            const isPageOnly = updatedKeys.length === 1 && updatedKeys[0] === 'page';
            if (isPageOnly) {
              return EMPTY;
            }
          }
          const cleanedFilters = this.helperService.cleanFilters(filters);
          return this.propertyListService.getProperties(cleanedFilters).pipe(
            map(r => {
              if (r.success) {
                return propertyListActions.loaded({
                  status: 'success',
                  items: r.data.items,
                  totalNumberOfItems: r.data.totalNumberOfItems,
                  pageNumber: r.data.pageNumber,
                  pageSize: r.data.pageSize,
                  message: '',
                  hasMore: r.data.hasMore,
                  append: (action as any)?.append ?? false
                });
              }
              this.messageService.showSnackbar(r.niceErrorMessage, ToastSeverity.Error);
              return propertyListActions.loaded({
                status: 'error',
                message: r.niceErrorMessage,
                items: null,
                pageSize: null,
                pageNumber: null,
                hasMore: false,
                totalNumberOfItems: null,
                append: false
              });
            })
          );
        }
      )
    )
  );

}
